<div
  class="dialog-overlay"
  *ngIf="slideState === 'hidden' || slideState === 'visible'"
  (click)="closeModal()"
></div>

<div class="dialog-box" [@slideDialog]="slideState">
  <div
    class="card"
    tabindex="0"
    role="button"
    [attr.aria-label]="'Card for ' + card?.artName"
  >
    <div class="user-card-image grid-pile">
      <canvas #canvas class="card-canvas" style="image-rendering: smooth;"></canvas>
      <img class="canvas" style="height:300px;object-fit: contain;" width="700" height="300" [src]="this.card?.imageUrl || this.card?.artThumbnailUploadUrl || this.card?.artThumbnailUrl" alt="">
    </div>
    <div class="card-info flex flex-col">
      <div class="flex justify-between items-center">
        <h3>{{ card?.artistName || "" }}</h3>
        <p>
          {{ (card?.placeName || card?.city) + (((card?.placeName || card?.city || "") && card?.country) ? ", " : "") }}
          {{ card?.country || "" }}
        </p>
      </div>

      <div class="flex justify-between items-center">
        <p *ngIf="card?.artPrice || card?.price"><b>Price:</b> {{ (card?.price || card?.artPrice) | currency:'USD':'symbol':'1.2-2' }}</p>
        <p style="margin-left: auto;">{{ card?.artName || "" }}</p>
      </div>
      <div *ngIf="role === 'AUDIENCE' && card?.price" class="flex justify-between items-center">
        <p><i>Yearly Subscription</i></p>
      </div>
      <div class="card-user">
        <p class="card-description">{{ card?.description || "" }}</p>
      </div>
      <div *ngIf="!isArtistPreview && !card?.price && role === 'AUDIENCE' && card?.artistId != artistId && !card?.subscribed" class="flex" class="warning-text">
        <svg style="width: .85rem;margin-inline-end: .4em;" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#ffffff" fill-rule="evenodd" d="M10 3a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0zm10.01 4a1 1 0 01-1 1H10a1 1 0 110-2h.01a1 1 0 011 1zM11 6a1 1 0 10-2 0v5a1 1 0 102 0V6z"></path> </g></svg>
        <p style="font-size: 12px"><i>This artwork isn't priced yet. Interested in subscribing? Request the price below and we will notify you once the artist sets it.</i></p>
      </div>
    </div>


    <div *ngIf="!isArtistPreview" class="frame-subscribe-btn flex justify-between items-center">
      <app-button [disabled]="disableAllActions || role !== 'GUEST'" (click)="isLoginPopupOpen = true" [text]="card?.subscribed ? 'Add to Frame' : 'Test on Frame'"/>
      <ng-container *ngIf="role === 'GUEST'">
        <app-button [disabled]="disableAllActions" (onClick)="makePayment()" text="Subscribe" />
      </ng-container>
      <ng-container *ngIf="!card?.subscribed && role === 'AUDIENCE' && card?.artistId != artistId">
        <app-button *ngIf="card?.price" [disabled]="disableAllActions" (onClick)="makePayment()" text="Subscribe" />
        <app-button *ngIf="!card?.price" (onClick)="requestPrice()" text="Request Price"/>
      </ng-container>
    </div>

    <button
      *ngIf="!disableAllActions"
      class="like-button flex items-center justify-center"
      (click)="toggleLike($event)"
      [attr.aria-label]="'Toggle like for ' + card?.artName"
    >
      <img
        [src]="
          liked ? 'assets/images/fav-red.svg' : 'assets/images/fav-black.svg'
        "
        alt="Like icon"
      />
    </button>

    <div class="edit-button" *ngIf="role === 'ARTIST'"
     (click)="toggleMenu($event)">
      <img
        [src]="menuOpen ? 'assets/images/OBDEA.svg' : 'assets/images/OBDE.svg'"
        alt="edit"
      />
    </div>
  
  
    <div class="dropdown-container">
      <div class="dropdown-menu"
        appClickOutside
        [isOpen]="menuOpen"
        (clickOutside)="menuOpen = false" 
        *ngIf="menuOpen">
        <button
          class="dropdown-item flex flex-nowrap gap-3 justify-center items-center"
          (click)="editArt()"
        >
          <img src="assets/images/border_color.svg" alt="border_color" />{{
            "Edit"
          }}
        </button>
  
        <button
          class="dropdown-item flex flex-nowrap gap-3 justify-center items-center"
          (click)="deleteArt()"
        >
          <img src="assets/images/delete.svg" alt="delete" />{{ "Delete" }}
        </button>
        <button
          class="dropdown-item album-btn flex flex-nowrap gap-3 justify-center items-center"
          (click)="addToAlbum()"
        >
          {{ isArtInAlbum ? "Remove from album" : "Add to album" }} 
        </button>
  
        <div class="top-arrow"></div>
      </div>
    </div>
  </div>
</div>


<app-make-payment [art]="card" *ngIf="isPayment" (close)="isPayment=false"></app-make-payment>


<app-guest-login *ngIf="isLoginPopupOpen"
(close)="isLoginPopupOpen = false">
</app-guest-login>